import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import styled from 'styled-components'

import config from '../config'
import { device } from '../media'

import Sidebar from '../components/Sidebar'
import FadeIn from '../components/FadeIn'
import NavLink from '../components/NavLink'
import MobileHeader from '../components/MobileHeader'

import './index.css'
import favicon from '../assets/favicon.png'

const Main = styled.main`
  padding: 0 ${config.padding} 0;
  margin: 2.499399183rem 0 0;
  visibility: ${props => props.hide ? 'hidden' : 'visible'}
  @media ${device.mobile} {
    padding: 0 10% 0 ${config.padding};
    margin: 2.499399183rem 0 0 40%;
    display: block;
  }
`

const Footer = styled.footer`
  font-size: ${config.finePrintFontSize};
  padding: ${config.padding};
  color: ${config.navLinkColor};
  margin-top: 0.889209325rem;
  @media ${device.mobile} {
    margin-left: 40%;
  }
`

class TemplateWrapper extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false
    }
  }

  componentWillUpdate = (prevProps, prevState) => {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState((prevState, props) => ({
        loading: true
      }));
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState((prevState, props) => ({
        loading: false
      }));
    }
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      return true
    }
    return false
  }

  render() {
    return (
      <div>
        <Helmet title={config.title}>
          <html lang='en' />
          <meta property="og:title" content={config.title} />
          <meta property="og:image" content="https://firstprinciple.team/first-principle-logo.jpg" />
          <link rel='shortcut icon' type='image/png' href={favicon} />
          {/* Start of HubSpot Embed Code */}
          <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/4426351.js"></script>
          {/* End of HubSpot Embed Code */}
        </Helmet>

        <MobileHeader />

        <Sidebar />

        <Main id='main' hide={this.state.loading}>
          {this.props.children()}
        </Main>

        <FadeIn><Footer id='footer'>All content © First Principle</Footer></FadeIn>
      </div>
    )
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js